var enUS = {
  "Accordion.dragAriaLabel": "This Accordion is draggable. Activate Tab to focus the drag handle.",
  "ActionToolbar.action": "Action",
  "ActionToolbar.itemButton": "Action button",
  "ActionToolbar.moreActions": "More actions",
  "ActivateToEdit.cancelLabel": "Cancel",
  "ActivateToEdit.canceledPrefix": "Edit canceled",
  "ActivateToEdit.confirmLabel": "Save. Activate to save and exit edit.",
  "ActivateToEdit.confirmedPrefix": "Edit saved",
  "ActivateToEdit.editInstructions": "Ready to edit. Activate Escape to cancel edit. To save, activate Enter.",
  "ActivateToEdit.instructions": "This content is editable. To edit, activate Spacebar or Enter. Activate Escape to cancel edit.",
  "AvatarCluster.clusterLabel": "Group of user avatars",
  "AvatarCluster.defaultTooltipContent": "Includes {{firstUser}}, {{secondUser}}, {{thirdUser}}, and others",
  "AvatarCluster.tooltipContentForSingleUser": "Includes {{user}}",
  "AvatarCluster.tooltipContentForThreeUsers": "Includes {{firstUser}}, {{secondUser}}, and {{thirdUser}}",
  "AvatarCluster.tooltipContentForTwoUsers": "Includes {{firstUser}} and {{secondUser}}",
  "AvatarTeam.avatarLabel": "Team Avatar",
  "AvatarUser.editAvatar": "Edit Avatar",
  "AvatarUser.unknownUserLabel": "Unknown user",
  "AvatarUser.userAvatarLabel": "User Avatar",
  "Banner.dismissButton": "Dismiss banner",
  "Breadcrumb.collapsedItems": "Collapsed Breadcrumb",
  "Breadcrumb.defaultLabel": "Breadcrumb",
  "Breadcrumb.showPaths": "Show paths",
  "ButtonGroup.buttonGroup": "Button Group",
  "ButtonGroup.checkboxGroup": "Checkbox Group",
  "ButtonGroup.radioGroup": "Radio Group",
  "CommentRow.deactivatedLabel": "Deactivated User",
  "CommentRow.moreActions": "More Actions",
  "ContentChipBase.closeButtonLabel": "Close",
  "DateInput.spinButtonLabel": "Select a date",
  "DateInputBase.calendarButtonLabel": "Open date picker",
  "DateInputBase.closeButtonLabel": "Clear value",
  "DateInputBase.dialogLabel": "Date picker",
  "DatePicker.dynamic": "Dynamic",
  "DatePicker.last14Days": "Last 14 days",
  "DatePicker.last30Days": "Last 30 days",
  "DatePicker.last60Days": "Last 60 days",
  "DatePicker.last7Days": "Last 7 days",
  "DatePicker.last90Days": "Last 90 days",
  "DatePicker.month": "Month",
  "DatePicker.next": "Next",
  "DatePicker.next14Days": "Next 14 days",
  "DatePicker.next30Days": "Next 30 days",
  "DatePicker.next60Days": "Next 60 days",
  "DatePicker.next7Days": "Next 7 days",
  "DatePicker.next90Days": "Next 90 days",
  "DatePicker.previous": "Previous",
  "DatePicker.previous12Months": "Previous 12 months",
  "DatePicker.previous2Months": "Previous 2 months",
  "DatePicker.previous2Quarters": "Previous 2 quarters",
  "DatePicker.previous2Weeks": "Previous 2 weeks",
  "DatePicker.previous3Months": "Previous 3 months",
  "DatePicker.previous3Quarters": "Previous 3 quarters",
  "DatePicker.previous3Weeks": "Previous 3 weeks",
  "DatePicker.previous4Quarters": "Previous 4 quarters",
  "DatePicker.previous4Weeks": "Previous 4 weeks",
  "DatePicker.previous6Months": "Previous 6 months",
  "DatePicker.previousMonth": "Previous month",
  "DatePicker.previousQuarter": "Previous quarter",
  "DatePicker.previousWeek": "Previous week",
  "DatePicker.previousYear": "Previous year",
  "DatePicker.selectMonth": "Select month",
  "DatePicker.thisMonth": "This month",
  "DatePicker.thisQuarter": "This quarter",
  "DatePicker.thisWeek": "This week",
  "DatePicker.thisYear": "This year",
  "DatePicker.timezoneHoursDecrease": "Decrease timezone hours",
  "DatePicker.timezoneHoursIncrease": "Increase timezone hours",
  "DatePicker.timezoneHoursLabel": "Timezone hours",
  "DatePicker.timezoneMeridianDecrease": "Decrease timezone meridian",
  "DatePicker.timezoneMeridianIncrease": "Increase timezone meridian",
  "DatePicker.timezoneMeridianLabel": "Timezone meridian",
  "DatePicker.timezoneMinutesDecrease": "Decrease timezone minutes",
  "DatePicker.timezoneMinutesIncrease": "Increase timezone minutes",
  "DatePicker.timezoneMinutesLabel": "Timezone minutes",
  "DatePicker.today": "Today",
  "DatePicker.week": "Week",
  "DatePicker.yearToDate": "Year to date",
  "DatePicker.yesterday": "Yesterday",
  "DateRangeInput.endButton": "Select an end date",
  "DateRangeInput.startButton": "Select a start date",
  "DndContext.announcements.onDragCancel": "Dragging was cancelled. Draggable item {{itemId}} was dropped.",
  "DndContext.announcements.onDragEndWithDroppable": "Draggable item {{itemId}} was dropped over droppable area {{targetDroppableId}}",
  "DndContext.announcements.onDragEndWithoutDroppable": "Draggable item {{itemId}} was dropped.",
  "DndContext.announcements.onDragOverWithDroppable": "Draggable item {{itemId}} was moved over droppable area {{targetDroppableId}}.",
  "DndContext.announcements.onDragOverWithoutDroppable": "Draggable item {{itemId}} is no longer over a droppable area.",
  "DndContext.announcements.onDragStart": "Picked up draggable item {{itemId}}.",
  "IconHost.categoryIcon": "{{category}} icon",
  "Listbox.deselectAll": "Deselect All",
  "Listbox.endAdornmentAction": "End Adornment Action",
  "Listbox.selectAll": "Select All",
  "Listbox.startAdornmentAction": "Start Adornment Action",
  "NavTabsList.secondaryNavigation": "Secondary navigation",
  "Popover.dismissButton": "Dismiss",
  "ProgressBar.error": "Error",
  "Ratings.defaultLegend": "Rating",
  "Ratings.label": "Rating {{ratingString}}",
  "Search.defaultPlaceholder": "Search...",
  "Search.searching": "Searching for results",
  "Search.showSearchResults": "Showing search results",
  "Select.noOptions": "No Options",
  "Select.noSelection": "No Selection",
  "Select.searchOptions": "Search Options",
  "Tabs.removeTab": "Remove tab",
  "Tabs.scrollLeft": "Scroll left",
  "Tabs.scrollRight": "Scroll right",
  "Tag.removeTag": "Remove Tag",
  "Timestamp.defaultDateTime": "{{dateString}} at {{timeString}}",
  "Timestamp.invalidDate": "invalid date",
  "Timestamp.lessThanOneDayAgo": "{{hoursString}} hours ago",
  "Timestamp.lessThanOneHourAgo": "{{minutesString}} minutes ago",
  "Timestamp.lessThanOneMinuteAgo": "A few seconds ago",
  "Timestamp.lessThanTwoHoursAgo": "One hour ago",
  "Timestamp.lessThanTwoMinutesAgo": "One minute ago",
  "Toast.close": "Close toast",
  "Toast.destroy": "Never show this again",
  "Toast.srOnly": "notification appears",
  "Toast.titleMap.error": "Uh oh",
  "Toast.titleMap.generic": "Note",
  "Toast.titleMap.info": "Information",
  "Toast.titleMap.progress": "In Progress...",
  "Toast.titleMap.success": "Success!",
  "Toast.titleMap.warning": "Warning",
  "ToastsContainer.alert": "Alert toasts live region",
  "ToastsContainer.status": "Status toasts live region",
  "TreeDynamic.error": "An error occurred",
  "TreeDynamic.loading": "Loading...",
  "Uploader.downloadTemplate": "Download Template",
  "Uploader.dragAndDropInfo_one": "Drag and drop file here",
  "Uploader.dragAndDropInfo_other": "Drag and drop files here",
  "Uploader.error.exceededFileLimit": "File limit is exceeded",
  "Uploader.error.invalidFileFormat": "File format is invalid",
  "Uploader.removeFile": "Remove file",
  "Uploader.seeLess": "See less",
  "Uploader.seeMore": "See more",
  "Uploader.selectActionsInfo": "or select an option below",
  "Uploader.upload": "upload"
};

export { enUS as default };
